<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--header-->
<!--      <div class="nav_bar">-->
<!--        <button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
<!--        <p class="clear_style fl nav_bar_search tc">{{currentName}}</p>-->
<!--      </div>-->

      <!--<div  style="height:auto;">-->
        <!--<iframe id="show-iframe" frameborder="0" scrolling="yes" style="background-color:transparent;position: absolute;width: 100%;height:100% ; top: 0;left:0;bottom:0;" :src='htmlUrl' alt="未加载出来"></iframe>-->
      <!--</div>-->
      <div id="container"></div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { cartToOrderImputedPrice,getProductPromoCodeAvailable,createOrder,login } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'parkInfo',
    data() {
      return {
        token:"",
        showLoading:false,
        htmlUrl:'https://map.baidu.com/mobile/webapp/place/detail/qt=ninf&industry=hotel&src_from=kuanghotelmap&uid=93eb05ac97cdae8f3586f4f7/vt=map',
        currentName:this.$route.query.storeName == undefined ? "杭州 Hello Kitty 乐园":this.$route.query.storeName,
        currentId:this.$route.query.storeId
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh,
    },
    methods: {
      async initData() {

        var center;

        //调用初始化函数
        if (this.currentId == "CastleHotel") {
          this.htmlUrl = "https://map.qq.com/m/place/info/uid=11089054562338400245&word=%E9%93%B6%E6%B6%A6%E5%B0%8F%E9%95%87%E8%9D%B6%E6%9D%A5%E9%85%92%E5%BA%97&type=point&searchBar=undefined&refer=undefined&backToList=undefined"
          center = new qq.maps.LatLng(30.621424,119.736643);
        } else if (this.currentId == "TownHotel") {
          this.htmlUrl = "https://map.qq.com/m/place/info/uid=11089054562338400245&word=%E9%93%B6%E6%B6%A6%E5%B0%8F%E9%95%87%E8%9D%B6%E6%9D%A5%E9%85%92%E5%BA%97&type=point&searchBar=undefined&refer=undefined&backToList=undefined"
          center = new qq.maps.LatLng(30.623723,119.740575);
        } else {
          center = new qq.maps.LatLng(30.6208900000,119.7408400000);
        }

        var map = new qq.maps.Map(document.getElementById('container'),{
          center: center,
          zoom: 13,
          mapStyleId: 'style1'  // 该key绑定的style1对应于经典地图样式，若未绑定将弹出无权限提示窗
        });
        var marker = new qq.maps.Marker({
          position: center,
          map: map,
        });
        var anchor = new qq.maps.Point(0, 39),
          size = new qq.maps.Size(42, 68),
          origin = new qq.maps.Point(0, 0),
          markerIcon = new qq.maps.MarkerImage(
            "https://3gimg.qq.com/lightmap/api_v2/2/4/99/theme/default/imgs/marker.png",
            size,
            origin,
            anchor
          );
        marker.setIcon(markerIcon);

      },
    },
    mounted() {
      this.initData();
    },


  }
</script>

<style lang="scss" scoped>

  #container{
    min-width:600px;
    min-height:767px;
  }

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-top: 2.5rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .animate_action {
    transition:all .4s;
  }


  .coupon_item {
    height: 7rem;
  }


</style>



// WEBPACK FOOTER //
// src/components/page/ticket/storeMap.vue